import React from 'react';
import { Table } from 'react-bootstrap';
import { getContact } from '../firebase/contact';
import Pagination from "react-js-pagination";

class ContactInfo extends React.Component {
    constructor(props) {
        super(props) 
        this.state = {
            contactInfo: [],
            activePage: 1,
            itemPerPage: 5,
        }
        this.handlePageChange = this.handlePageChange.bind(this)
    }

    handlePageChange(pageNumber) {
        console.log(`active page is ${pageNumber}`);
        this.setState({activePage: pageNumber});
    }

    componentDidMount() {
        getContact().then(contacts => {
            this.setState({ contactInfo : contacts}) 
        })
    }
    render() {
        const {activePage, itemPerPage, contactInfo} = this.state
        return(
            <div className="client-contact-info">
                <h3>List of customers have tried to reach you</h3>
                <Table responsive="sm" bordered striped>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Name</th>
                            <th>Phone</th>
                            <th>Email</th>
                            <th>Message</th>
                        </tr>
                    </thead>
                    {contactInfo.slice((activePage - 1)* itemPerPage,  activePage*itemPerPage).map(contact => 
                        <tbody key={contact.id}>
                            <tr>
                                <td>{new Date(contact.time).toLocaleString()}</td>
                                <td>{contact.name}</td>
                                <td>{contact.phone}</td>
                                <td>{contact.email}</td>
                                <td>{contact.text}</td>
                            </tr>
                        </tbody>
                    )}
                </Table>
                <div className="pagination">
                    <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={this.state.itemPerPage}
                        totalItemsCount={this.state.contactInfo.length}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChange}
                    />
                </div>
            </div>
        )
    }
}

export default ContactInfo